import { Formik } from 'components/form/formik';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Button } from '../../../components/button/Button';
import { InputField } from '../../../components/input/InputField';
import { PageHeader } from '../../../components/PageHeader';
import { getDisplayError } from '../../../utils/get-display-error';
import { createInternalUser } from '../models';
import { PlusIcon } from '@phosphor-icons/react';
import { captureException } from '@sentry/react';

const createUserSchema = Yup.object().shape({
  name: Yup.string().min(1, 'Vereist').required('Vereist'),
  email: Yup.string().email('Ongeldig email').required('Vereist'),
});

const CreateUserPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Nieuwe gebruiker" />

      <div className="grid gap-4">
        <h2 className="heading-two">Nieuwe gebruiker</h2>

        <Formik
          initialValues={{ name: '', email: '' }}
          validationSchema={createUserSchema}
          onSubmit={async (values) => {
            try {
              const result = await createInternalUser(values);
              navigate(`../${result.user.id}`, { replace: true });
              toast.success('Gebruiker aangemaakt');
            } catch (err: any) {
              captureException(err);
              toast.error('Kon gebruiker niet aanmaken: ' + getDisplayError(err));
            }
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit} className="grid gap-4">
              <div className="card p-5">
                <InputField labelText="Naam" type="text" name="name" />
                <InputField labelText="Email" type="email" name="email" />
              </div>

              <div>
                <Button
                  type="submit"
                  color="primary"
                  iconLeft={<PlusIcon className="button-icon" />}
                  isDisabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  Maak gebruiker aan
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateUserPage;
